import { formatHora } from "../data/mock";

const dotColor = {
    ronda: "bg-emerald-500 ring-emerald-500/30",
    ronda_iniciada: "bg-emerald-500 ring-emerald-500/30",
    ronda_finalizada: "bg-emerald-400 ring-emerald-400/30",
    ocorrencia: "bg-amber-500 ring-amber-500/30",
    emergencia: "bg-red-500 ring-red-500/40",
    passagem: "bg-blue-500 ring-blue-500/30",
};

export const EventTimeline = ({ events }) => {
    if (!events?.length) {
        return (
            <p className="text-sm text-slate-500 italic px-4 py-6 text-center">
                Nenhum evento registrado ainda.
            </p>
        );
    }
    return (
        <ol className="relative pl-6" data-testid="event-timeline">
            <span className="absolute left-2 top-2 bottom-2 w-px bg-white/10" />
            {events.map((ev, i) => (
                <li
                    key={ev.id || i}
                    className="relative pb-5 last:pb-0"
                    data-testid={`timeline-event-${ev.tipo}`}
                >
                    <span
                        className={`absolute -left-4 top-1 w-3 h-3 rounded-full ring-4 ${
                            dotColor[ev.tipo] || "bg-slate-500 ring-slate-500/30"
                        }`}
                    />
                    <div className="flex items-baseline gap-3">
                        <span className="font-mono-data text-xs text-slate-400">
                            {formatHora(ev.criadoEm)}
                        </span>
                        <span className="tiny-label text-slate-500">
                            {ev.tipoLabel}
                        </span>
                    </div>
                    <p className="text-sm mt-0.5 leading-relaxed">{ev.titulo}</p>
                    {ev.subtitulo && (
                        <p className="text-xs text-slate-500 mt-0.5">
                            {ev.subtitulo}
                        </p>
                    )}
                </li>
            ))}
        </ol>
    );
};
